import { render, staticRenderFns } from "./AppointmentsRevertModal.vue?vue&type=template&id=30c9afab&scoped=true&"
import script from "./AppointmentsRevertModal.vue?vue&type=script&lang=js&"
export * from "./AppointmentsRevertModal.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentsRevertModal.vue?vue&type=style&index=0&id=30c9afab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c9afab",
  null
  
)

export default component.exports